import FooterAddress from './FooterAddress'
export default FooterAddress
